module.exports = __webpack_public_path__ + "img/D_read_more_plan.8a3796c0.svg";